import { FC } from "react";
import "./styles.scss";
import { PageShell } from "../PageShell";
import { useTranslation } from "../../../hooks/useTranslation";
import { TESTIMONIAL_IDS } from "./testimonials";
import { TestimonialCard } from "./TestimonialCard";

interface TestimonialContent {
  quote: string;
  author: string;
  affiliation: string;
}

export const TestimonialsPage: FC = () => {
  const { p } = useTranslation("landing_testimonials");

  // See TeamPage/index.tsx for why this cast is needed: this project's
  // translation bundles aren't typed, so i18next can't infer the shape of
  // an object returned via `returnObjects`.
  const items = p("items", { returnObjects: true }) as unknown as Record<
    string,
    TestimonialContent
  >;

  return (
    <PageShell>
      <div className="landing-testimonials-page">
        <h1 className="landing-testimonials-page__heading">{p("heading")}</h1>

        <div className="landing-testimonials-page__grid">
          {TESTIMONIAL_IDS.map((id) => {
            const content = items?.[id];
            if (!content) return null;
            return (
              <TestimonialCard
                key={id}
                quote={content.quote}
                author={content.author}
                affiliation={content.affiliation}
              />
            );
          })}
        </div>
      </div>
    </PageShell>
  );
};
